"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/policyViewModel',["require", "exports", "knockout", "services/customerSelection", "services/policySummaryService", "services/dataAggregatorService", "viewModels/policyVehicleViewModel", "viewModels/addressViewModel", "services/journeyService", "moment"], function (require, exports, ko, customerSelection, policySummaryService, dataAggregatorService, PolicyVehicleViewModel, AddressViewModel, journeyService, moment) {
    "use strict";

    var PolicyViewModel = function () {
        function PolicyViewModel() {
            _classCallCheck(this, PolicyViewModel);

            this.baseTimezoneId = 'Europe/London';
            this.policy = ko.observable(null);
            this.policyholder = ko.observable(null);
            this.homeAddress = ko.observable(null);
            this.shippingAddress = ko.observable(null);
            this.vehicles = ko.observableArray([]);
            this.vehicleCount = ko.observable(0);
            this.isScored = ko.observable(false);
            this.vehicle = ko.pureComputed(this.computeVehicle, this);
            this.policyholderFullName = ko.pureComputed(this.computePolicyholderFullName, this);
            this.devices = ko.observableArray([]);
            this.policySummary = ko.observable();
            this.policySummaryBlob = ko.observable();
            this.journeyStats = ko.observable();
            this.lastKnownLocation = ko.observable(null);
            this.lastKnownLocationInterval = null;
            this.latestPacketDate = ko.observable('');
            this.latestPacketDateGPS = ko.observable('');
            this.latestPolicyAggregatorData = ko.observable(null);
            this.tileIndex = 200;
        }

        _createClass(PolicyViewModel, [{
            key: "setPolicy",
            value: function setPolicy(policyDetails) {
                this.getDeviceAllocations(policyDetails.policy.id);
                this.environment = policyDetails.environment;
                this.policyholder(policyDetails.policyholder);
                this.homeAddress(new AddressViewModel(policyDetails.homeAddress));
                this.shippingAddress(policyDetails.shippingAddress ? new AddressViewModel(policyDetails.shippingAddress) : null);
                this.vehicles([new PolicyVehicleViewModel(policyDetails.vehicle)]);
                this.vehicleCount(policyDetails.vehicleCount);
                this.policy(policyDetails.policy);
                this.isScored(policyDetails.policy.appType === 'scored');
                policySummaryService.getPolicySummary(this.policy().id, this.policy().coverStartDate, this.policy().coverEndDate, this.policy().coverCancelledDate).then(this.getPolicySummarySuccess.bind(this));
                dataAggregatorService.getLatestPolicyData(this.policy().id, this.policy().coverEndDate).then(this.getLatestPolicyDataSuccess.bind(this));
                journeyService.getJourneyStats(this.policy().id).then(this.getJourneyStatsSuccess.bind(this));
                if (this.policy().policyStatus.toLowerCase() === 'active') {
                    this.getLastKnownLocation();
                }
                if (this.policy().policyStatus.toLowerCase() === 'renewed' && moment(this.policy().coverEndDate) >= moment(new Date())) {
                    this.getLastKnownLocation();
                }
            }
        }, {
            key: "getDeviceAllocations",
            value: function getDeviceAllocations(policyId) {
                return customerSelection.getDeviceAllocations(policyId).then(this.setDeviceAllocations.bind(this));
            }
        }, {
            key: "setDeviceAllocations",
            value: function setDeviceAllocations(deviceAllocations) {
                this.devices(deviceAllocations.allocations);
                this.latestPacketDate(deviceAllocations.latestPacketDate);
                this.latestPacketDateGPS(deviceAllocations.latestPacketDateGPS);
                this.devicesDeferred.resolve();
            }
        }, {
            key: "computeVehicle",
            value: function computeVehicle() {
                return this.vehicles().find(function (v) {
                    return v.isActive();
                }) || this.vehicles()[0];
            }
        }, {
            key: "computePolicyholderFullName",
            value: function computePolicyholderFullName() {
                return this.policyholder().name + ' ' + this.policyholder().surname;
            }
        }, {
            key: "getPolicySummarySuccess",
            value: function getPolicySummarySuccess(policySummary) {
                this.policySummary(policySummary);
                this.policySummaryDeferred.resolve();
            }
        }, {
            key: "getLatestPolicyDataSuccess",
            value: function getLatestPolicyDataSuccess(data) {
                this.latestPolicyAggregatorData(data);
            }
        }, {
            key: "getJourneyStatsSuccess",
            value: function getJourneyStatsSuccess(journeyStats) {
                if (journeyStats) {
                    this.journeyStats(journeyStats);
                }
                this.journeyStatsDeferred.resolve();
            }
        }, {
            key: "getPolicySummaryBlob",
            value: function getPolicySummaryBlob(requesterTile) {
                return policySummaryService.getPolicySummaryBlob(this.policy().id, this.policy().brokerPolicyId, this.policyholder().name + ' ' + this.policyholder().surname, this.policy().brokerPolicyHolderId, this.policy().coverStartDate, requesterTile).then(this.getPolicySummaryBlobSuccess.bind(this));
            }
        }, {
            key: "getPolicySummaryBlobSuccess",
            value: function getPolicySummaryBlobSuccess(policySummaryBlob) {
                this.policySummaryBlob(policySummaryBlob);
                this.policySummaryBlobDeferred.resolve();
            }
        }, {
            key: "resetDeferreds",
            value: function resetDeferreds() {
                this.devicesDeferred = $.Deferred();
                this.policySummaryDeferred = $.Deferred();
                this.policySummaryBlobDeferred = $.Deferred();
                this.journeyStatsDeferred = $.Deferred();
            }
        }, {
            key: "getNewIndex",
            value: function getNewIndex(tileId) {
                this.tileIndex++;
                return { id: tileId, index: this.tileIndex };
            }
        }, {
            key: "dontTrackLastKnownLocation",
            value: function dontTrackLastKnownLocation() {
                if (this.lastKnownLocationInterval) {
                    clearInterval(this.lastKnownLocationInterval);
                }
            }
        }, {
            key: "trackLastKnownLocation",
            value: function trackLastKnownLocation() {
                this.getLastKnownLocation();
                var that = this;
                if (!this.lastKnownLocationInterval) {
                    this.lastKnownLocationInterval = setInterval(function () {
                        that.getLastKnownLocation();
                    }.bind(this), 10000);
                }
            }
        }, {
            key: "getLastKnownLocation",
            value: function getLastKnownLocation() {
                if (this.policy()) {
                    customerSelection.getLastKnownLocation(this.policy().brokerPolicyId, this.policy().coverStartDate, this.policy().coverEndDate).then(this.lastKnownLocation.bind(this));
                } else {
                    this.lastKnownLocation(null);
                }
            }
        }, {
            key: "getAllVehicles",
            value: function getAllVehicles() {
                var _this = this;

                return customerSelection.getAllVehicles(this.policy().id).then(function (vehicles) {
                    if (vehicles) {
                        var temp = [];
                        $.each(vehicles, function (ind, veh) {
                            temp.push(new PolicyVehicleViewModel(veh));
                        });
                        _this.vehicles(temp);
                    }
                });
            }
        }, {
            key: "getSentinelLogPolicyDetails",
            value: function getSentinelLogPolicyDetails() {
                return {
                    environment: this.environment,
                    policyId: this.policy().id,
                    brokerPolicyId: this.policy().brokerPolicyId,
                    policyHolderFullName: this.policyholder().name + ' ' + this.policyholder().surname,
                    brokerPolicyHolderId: this.policy().brokerPolicyHolderId
                };
            }
        }, {
            key: "clear",
            value: function clear() {
                this.vehicles.removeAll();
                this.policy(null);
                this.policyholder(null);
                this.homeAddress(null);
                this.shippingAddress(null);
                this.devices([]);
                this.policySummary(null);
                this.policySummaryBlob(null);
                this.journeyStats(null);
                if (this.lastKnownLocationInterval) {
                    clearInterval(this.lastKnownLocationInterval);
                }
                this.latestPacketDate('');
                this.lastKnownLocation(null);
                this.latestPolicyAggregatorData(null);
            }
        }]);

        return PolicyViewModel;
    }();

    return new PolicyViewModel();
});
//# sourceMappingURL=policyViewModel.js.map;
